import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'youtubeId',
    standalone: false
})
export class YoutubeIdPipe implements PipeTransform {
  transform(urlOrId: string): string {
    if (!urlOrId) return '';
    // If it's already a valid YouTube video ID (11 chars, alphanumeric, - or _)
    if (/^[\w-]{11}$/.test(urlOrId)) {
      return urlOrId;
    }
    // Otherwise, try to extract from a full URL
    const regExp = /(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?|shorts)\/|.*[?&]v=)|youtu\.be\/)([\w-]{11})/;
    const match = urlOrId.match(regExp);
    return match ? match[1] : '';
  }
} 